import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2058d117"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "unity-widget" }
const _hoisted_2 = { class: "unity-viewer-model" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-mb viewer-footer" }, [
  /*#__PURE__*/_createTextVNode(" Bovenstaand 3D ontwerp is indicatief, er kunnen dus geen rechten aan worden ontleend."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Voor eventuele vragen kunt u contact opnemen met "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://hofzichtmakelaars.nl/"
  }, " Hofzicht Makelaars. ")
], -1))

import { computed, onMounted, ref } from 'vue'
import { ls } from '@/ls'
import UnityWebGL from 'unity-webgl'
import VueUnity from 'unity-webgl/vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UnityWidget',
  setup(__props) {

const unitySettings = new UnityWebGL({
  productVersion: '2025',
  productName: 'WoononViewer',
  companyName: 'Thunnissen',
  loaderUrl: '/viewer/Build/UnityWeb2022.loader.js',
  dataUrl: '/viewer/Build/UnityWeb2022.data',
  frameworkUrl: '/viewer/Build/UnityWeb2022.framework.js',
  codeUrl: '/viewer/Build/UnityWeb2022.wasm'
})

const building = computed(() => ls.get('building'))
const showUnityModal = ref(false)
const modalHeight = computed(() => window.innerHeight * 0.9)
const modalWidth = computed(() => modalHeight.value * 16 / 9)

onMounted(() => {
  setBuildingId()
})

function setBuildingId () : void {
  localStorage.setItem('viewer-building-id', building.value.id.toString())
}

function closeModal () : void {
  unitySettings.unload().then(() => {
    showUnityModal.value = false
  })
}

function sendCommand (method: string, params: string | number | null): void {
  unitySettings.send('VueHookLight', method, params === null ? null : params.toString())
}

function onFullScreenClicked () : void {
  unitySettings.setFullscreen(true)
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_a_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showUnityModal.value = true))
    }, {
      default: _withCtx(() => [
        _createTextVNode("Bekijk woning in 3D")
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      width: _unref(modalWidth),
      centered: "",
      height: _unref(modalHeight),
      "body-style": { padding: 0, marginBottom: '-6px' },
      visible: showUnityModal.value,
      closable: false
    }, {
      footer: _withCtx(() => [
        _hoisted_3,
        _createVNode(_component_a_button, { onClick: onFullScreenClicked }, {
          default: _withCtx(() => [
            _createTextVNode("Volledig scherm")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, { onClick: closeModal }, {
          default: _withCtx(() => [
            _createTextVNode("Sluiten")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_spin, { class: "loading-spinner" }),
          (showUnityModal.value)
            ? (_openBlock(), _createBlock(_unref(VueUnity), {
                key: 0,
                unity: _unref(unitySettings),
                class: "viewer",
                width: "100%"
              }, null, 8, ["unity"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["width", "height", "visible"])
  ]))
}
}

})